<template>
  <div>
    <common-dialog
      ref="dialog"
      width="490px"
      center
      title="导入 学生图片信息"
      id-key="StudentId"
      :save-func="()=>{}"
      :confirm-on-close-change="false"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <div style="text-align: center;margin-bottom: 30px;">
          <div style="margin-top: 15px;display: inline-block;">
            <import-file :upload-url="api.importPhoto" text="导入图片信息" @on-uploaded="uploaded" />
          </div>
          <span class="tip">* 文件大小不能超过25mb，支持 .zip .7z .rar 格式的文件。</span>
        </div>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import importFile from "@/components/common/files/importFile";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    importFile,
  },
  data() {
    return {
      api: require("@/api/st/student").default,
    };
  },
  computed: {},
  methods: {
    uploaded(res) {
      console.log("uploaded", res);
      if (res.Code != 0) {
        this.$message.error(res.Msg);
      } else {
        this.$emit("upload-success");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.tip {
  font-size: 12px;
  margin-left: 10px;
  color: #e4510b;
}
</style>